import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { EventsAwardsStaticPageContext } from "@events-awards/StaticPage/utils/types";
import { Route } from "@route-types/Section/layouts/EventsAwards/StaticPage/+types/EventsAwardsStaticPage";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import { fetchEventsAwardsStaticPageContentData } from "./EventsAwardsStaticPage.server";
import EventsAwardsStaticPageContent from "./EventsAwardsStaticPageContent";

/** This is the main entry point component for events awards static content pages route. */
const EventsAwardsStaticPage = (): React.ReactElement => {
  const context = useLoaderData<EventsAwardsStaticPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <EventsAwardsStaticPageContent {...context.payload.data} />;
};

export default EventsAwardsStaticPage;

export const loader = async ({ request }: Route.LoaderArgs) => {
  const url = new URL(request.url, `http://localhost`);
  const path = url.pathname;

  return await fetchEventsAwardsStaticPageContentData(path);
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as EventsAwardsStaticPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
